import { CONTRACT_REGISTER_PR_LOAD, CONTRACT_REGISTER_PR_UNLOAD, CONTRACT_REGISTER_PR_ALL_COMPANIES_LOAD } from "../../actions/Constants";

const INITIAL_STATE = { all: null, allCompanies: [] };

export default function consultaChassiPR(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CONTRACT_REGISTER_PR_LOAD:
      return {
        ...state,
        all: action.payload ? action.payload : null,
      };
    case CONTRACT_REGISTER_PR_ALL_COMPANIES_LOAD:
      return {
        ...state,
        allCompanies: action.payload ? action.payload : null,
      };
    case CONTRACT_REGISTER_PR_UNLOAD:
      return INITIAL_STATE;
    default:
      return state;
  }
}
